// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cldyc40 {
  cursor: pointer;
}
.cldyc42:hover {
  cursor: pointer;
  color: #6E6F71;
}
.cldyc42:first-child {
  padding-left: var(--_18w76bwh);
}
.cldyc43 {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  flex-grow: 1;
  color: var(--_18w76bw33);
}
.cldyc45 {
  color: var(--_18w76bw33);
}
.cldyc45:hover {
  color: var(--_18w76bw33);
}
.cldyc45::after {
  content: "";
  position: absolute;
  bottom: -1px;
  display: block;
  height: 3px;
  width: calc(100% - 3rem);
  background-color: var(--_18w76bw33);
}
.cldyc46 {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  flex-grow: 1;
  color: #4a4b4d;
  background-color: #f3f3f3;
}
@media screen and (min-width: 768px) {
  .cldyc42 {
    font-size: 1.0625rem;
  }
  .cldyc43 {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    flex-grow: 0;
  }
  .cldyc46 {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    flex-grow: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;EACd;AACF","sourcesContent":[".cldyc40 {\n  cursor: pointer;\n}\n.cldyc42:hover {\n  cursor: pointer;\n  color: #6E6F71;\n}\n.cldyc42:first-child {\n  padding-left: var(--_18w76bwh);\n}\n.cldyc43 {\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  flex-grow: 1;\n  color: var(--_18w76bw33);\n}\n.cldyc45 {\n  color: var(--_18w76bw33);\n}\n.cldyc45:hover {\n  color: var(--_18w76bw33);\n}\n.cldyc45::after {\n  content: \"\";\n  position: absolute;\n  bottom: -1px;\n  display: block;\n  height: 3px;\n  width: calc(100% - 3rem);\n  background-color: var(--_18w76bw33);\n}\n.cldyc46 {\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  flex-grow: 1;\n  color: #4a4b4d;\n  background-color: #f3f3f3;\n}\n@media screen and (min-width: 768px) {\n  .cldyc42 {\n    font-size: 1.0625rem;\n  }\n  .cldyc43 {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    flex-grow: 0;\n  }\n  .cldyc46 {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    flex-grow: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
